import React from "react";
import {
    Typography
} from "antd";



function ModalWindowCmd() {


    return (
        <>


            <Typography.Paragraph>
                Entrez la commande
                <Typography.Text code copyable>`For /f %a in (liste_liens_mnx.txt) do curl -O -J %a`
                </Typography.Text> et appuyez sur ENTRÉE :
            </Typography.Paragraph>
            <img src={`${process.env.PUBLIC_URL}/dl_lidar_tuto_windows_cmd_3.png`} alt="Image indiquant les options proposer au click droit dans un dossier"
                style={{ width: "100%", maxWidth: 900 }} />

            <Typography.Paragraph>
                La sortie textuelle s'arrêtera quand tout sera terminé. Vous devriez avoir tous les fichiers dans votre dossier (vous pouvez supprimer le fichier listant les liens).
            </Typography.Paragraph>
        </>
    )

}

export default ModalWindowCmd